/* @jsx h */
import { defineComponent, h } from "vue";
import { useLocalization } from "@lemmonhq/uikit";

export const ContactForm = defineComponent({
  name: "ContactForm",
  props: {
    name: {
      type: String,
      required: true,
    },
    email: {
      type: String,
      required: true,
    },
    phone: {
      type: String,
      required: true,
    },
    notes: {
      type: String,
      default: "",
    },
  },
  emits: ["update:name", "update:email", "update:phone", "update:notes"],
  setup(props, { emit }) {
    const { t } = useLocalization();
    return () => (
      <div class="card bg-base-100 shadow-sm border border-base-200">
        <div class="card-body p-5">
          <div class="flex items-center gap-2 mb-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 text-primary"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              />
            </svg>
            <h3 class="card-title text-base font-semibold">
              {t("customer.reserve.contact_information")}
            </h3>
          </div>
          <p class="text-sm text-base-content/60 mb-4">
            {t("customer.reserve.confirmation_sent_here")}
          </p>

          <div class="space-y-4">
            {/* 2-column grid for required fields */}
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
              <div class="form-control">
                <label class="label py-1">
                  <span class="label-text text-xs font-medium uppercase tracking-wide text-base-content/70">
                    {t("customer.reserve.full_name")}
                  </span>
                  <span class="label-text-alt text-error">*</span>
                </label>
                <input
                  type="text"
                  value={props.name}
                  onInput={(e) =>
                    emit("update:name", (e.target as HTMLInputElement).value)
                  }
                  placeholder="Jean Dupont"
                  class="input input-bordered w-full bg-base-100 focus:input-primary focus:border-primary transition-all duration-200"
                  required
                />
              </div>

              <div class="form-control">
                <label class="label py-1">
                  <span class="label-text text-xs font-medium uppercase tracking-wide text-base-content/70">
                    {t("customer.reserve.email_address")}
                  </span>
                  <span class="label-text-alt text-error">*</span>
                </label>
                <input
                  type="email"
                  value={props.email}
                  onInput={(e) => {
                    const val = (e.target as HTMLInputElement).value;
                    emit("update:email", val);
                  }}
                  placeholder="jean@gmail.com"
                  class="input input-bordered w-full bg-base-100 focus:input-primary focus:border-primary transition-all duration-200"
                  required
                />
              </div>

              <div class="form-control">
                <label class="label py-1">
                  <span class="label-text text-xs font-medium uppercase tracking-wide text-base-content/70">
                    {t("customer.reserve.phone_number")}
                  </span>
                  <span class="label-text-alt text-error">*</span>
                </label>
                <input
                  type="tel"
                  value={props.phone}
                  onInput={(e) =>
                    emit("update:phone", (e.target as HTMLInputElement).value)
                  }
                  placeholder="+41 79 123 45 67"
                  class="input input-bordered w-full bg-base-100 focus:input-primary focus:border-primary transition-all duration-200"
                  required
                />
              </div>

              <div class="form-control">
                <label class="label py-1">
                  <span class="label-text text-xs font-medium uppercase tracking-wide text-base-content/70">
                    {t("customer.reserve.special_requests")}
                  </span>
                </label>
                <input
                  type="text"
                  value={props.notes}
                  onInput={(e) =>
                    emit("update:notes", (e.target as HTMLInputElement).value)
                  }
                  placeholder={t(
                    "customer.reserve.special_requests_placeholder",
                  )}
                  class="input input-bordered w-full bg-base-100 focus:input-primary focus:border-primary transition-all duration-200"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  },
});
